<template>
<div v-if="content.override" v-html="content.override"></div>
<Layout :classes="classes" :header="headerBackgroundColor">
    <TopperTall v-if="content.topper.data.format == 'tall'" :data="content.topper.data"></TopperTall>
    <TopperShort v-if="content.topper.data.format == 'short'" :post="content.post" :data="content.topper.data"></TopperShort>
    <Slices :slices="content.slices"></Slices>
</Layout>
</template>

<script>

import { computed } from 'vue';
import Layout from './Layout.vue';
import TopperTall from './TopperTall.vue';
import TopperShort from './TopperShort.vue';
import Slices from './Slices.vue';

export default {

    components: {
        TopperShort,
        TopperTall,
        Slices,
        Layout
    },

    props: ['title', 'content', 'classes'],

    setup(props) {

        const headerBackgroundColor = computed(() => {
            if (props.content.topper.data.format == 'tall') {
                return 'dark';
            }
            return props.content?.topper?.data?.options?.color_scheme || 'light';
        });

        return {
            headerBackgroundColor
        };
        
    }

}
</script>